var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.1 145.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d94c5;}.cls-2{fill:#d1e3f0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.18,145.79c-2.16-1.87-5-1.38-7.45-1.85q-29.07-5.53-46.41-29.41c-2.91-4-2.52-5,2.29-5.43,5.85-.58,10.83-.08,15.64,5,17.4,18.16,45.18,22.27,67.64,10.89,22.18-11.25,35.51-36,31.94-59.42-4.07-26.63-22.62-46.21-48-50.69A58.57,58.57,0,0,0,14.61,62.18a29.72,29.72,0,0,0,.28,12.38C17,83.39,20.51,86.22,29.44,86.23h55c1.82,0,3.73.25,5.37-.72a5.09,5.09,0,0,0,2.38-6C91.41,76.39,88.88,76,86.29,76q-17,0-34,0c-14.89,0-22.83-9.84-20.18-24.67,1.2-6.71,8.94-15.06,17.62-14.74,16.13.6,32.3.13,48.45.2,5.89,0,8.87,3.2,7.91,8.2-.93,4.83-4.72,5.58-8.74,5.61-9,.08-18,0-27,0-5,0-10-.07-15,0-3.92.08-6.3,2-6.31,6.13s2.65,5.32,6.29,5.31c11.82,0,23.64.14,35.46,0,17.78-.26,22.55,16.27,18,27.92-2.75,7.09-9.15,9.54-16.17,9.6-22.31.19-44.63.37-66.94,0C10.12,99.22,0,87.79,0,71.73.07,36.76,25.63,6.91,60.56,1c.94-.16,2,.13,2.62-1h20c6,2.71,12.66,3.34,18.67,6.15,31,14.5,48,46.41,42.09,79.29S110.54,142.55,76.23,145c-2.62.92-5.47-.43-8,.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.18,145.79c2.51-2,5.36-.66,8-.82l-.06.82Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoM);
export default __webpack_public_path__ + "static/media/logo_m.1341abd4331782a81e72f8ccc6b42ea0.svg";
export { ForwardRef as ReactComponent };